module.exports = __webpack_public_path__ + "static/1-b58c584370ffe2e6e07fc98acb4ead17.jpeg";